import { Users } from 'lucide-react'
import { APP_CONSTANTS } from '@/lib/constants/app'

export function CoordinatorList() {
  const openWhatsApp = (phone: string) => {
    const cleanPhone = phone.replace(/\D/g, '')
    window.open(`https://wa.me/91${cleanPhone}`, '_blank')
  }

  return (
    <div>
      <h4 className="font-semibold text-slate-900 mb-3">Contact YUVA Volunteers</h4>

      {/* Horizontal scrolling container */}
      <div className="relative">
        <div className="flex gap-3 overflow-x-auto pb-3 scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent pr-4">
          {APP_CONSTANTS.COORDINATORS.map((coordinator, index) => (
            <button
              key={coordinator.phone}
              onClick={() => openWhatsApp(coordinator.phone)}
              className={`flex-shrink-0 w-44 p-4 rounded-xl bg-white border border-slate-200 hover:border-green-500/50 hover:shadow-md transition-all text-left group ${
                index === APP_CONSTANTS.COORDINATORS.length - 1 ? 'mr-2' : ''
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Users className="w-5 h-5 text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-slate-900 text-sm truncate">
                    {coordinator.name}
                  </div>
                  <div className="text-xs text-slate-500">{coordinator.building}</div>
                  <div className="text-xs text-slate-400">{coordinator.phone}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
        {/* Fade indicator on right */}
        <div className="absolute right-0 top-0 bottom-3 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </div>
  )
}
